import type { ValidationTriState, WorkmanCardTriState } from "../types";

export function triSelect(
  value: ValidationTriState,
  onChange: (v: ValidationTriState) => void,
  id: string
) {
  const s = value === null ? "" : value ? "yes" : "no";
  return (
    <select
      id={id}
      value={s}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === "" ? null : v === "yes");
      }}
    >
      <option value="">Not checked</option>
      <option value="yes">Verified / OK</option>
      <option value="no">Issue / mismatch</option>
    </select>
  );
}

/** Workman card checklist: adds “Need to Be Applied” as a positive (same advance as Verified / OK). */
export function workmanCardSelect(
  value: WorkmanCardTriState,
  onChange: (v: WorkmanCardTriState) => void,
  id: string
) {
  const s =
    value === null
      ? ""
      : value === "need_to_apply"
        ? "need_apply"
        : value
          ? "yes"
          : "no";
  return (
    <select
      id={id}
      value={s}
      onChange={(e) => {
        const v = e.target.value;
        if (v === "") onChange(null);
        else if (v === "yes") onChange(true);
        else if (v === "need_apply") onChange("need_to_apply");
        else onChange(false);
      }}
    >
      <option value="">Not checked</option>
      <option value="yes">Verified / OK</option>
      <option value="need_apply">Need to Be Applied</option>
      <option value="no">Issue / mismatch</option>
    </select>
  );
}
